import axios from "./general/HttpClient";
import React, { useEffect } from "react";

import * as ImmersiveReader from "@microsoft/immersive-reader-sdk";

export const ImmersiveReaderView = () => {
    const [token, setToken] = React.useState<string>("");

    useEffect(() => {
        axios.get("/api/immersiveReader/token").then((response) => {
            setToken(response.data);
        });
    }, []);

    const buttonRef = React.useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (buttonRef.current) {
            ImmersiveReader.renderButtons({
                elements: [buttonRef.current],
            });
        }
    }, [buttonRef]);

    const [text, setText] = React.useState<string>("");
    const [language, setLanguage] = React.useState<string>("en-us");

    const startImmersiveReader = () => {
        let content = {
            title: "Immersive Reader",
            chunks: [
                {
                    content: `<p lang="${language}">${text}</p>`,
                    mimeType: "text/html",
                },
            ],
        };
        ImmersiveReader.launchAsync(token, "scadsys-immersive-reader", content, {});
    };

    return (
        <div className="flex flex-col gap-4 p-6">
            <div className="text-text">
                <label htmlFor="language-select" className="block text-sm font-medium text-text-strong mb-2">
                    Language: {language}
                </label>
                <select
                    id="language-select"
                    value={language}
                    onChange={(e) => setLanguage(e.target.value)}
                    className="block w-full px-3 py-2 border border-gray-300 rounded-md 
                               bg-background text-text
                               focus:outline-none focus:ring-2 focus:ring-brand focus:border-transparent
                               dark:border-gray-600"
                >
                    <option value="en-us">English</option>
                    <option value="af-za">Afrikaans</option>
                </select>
            </div>

            <div>
                <label htmlFor="text-input" className="block text-sm font-medium text-text-strong mb-2">
                    Text
                </label>
                <textarea
                    id="text-input"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    rows={10}
                    className="block w-full px-3 py-2 border border-gray-300 rounded-md 
                               bg-background text-text resize-y
                               focus:outline-none focus:ring-2 focus:ring-brand focus:border-transparent
                               dark:border-gray-600"
                    placeholder="Enter text to read..."
                />
            </div>

            <div
                ref={buttonRef}
                className="immersive-reader-button cursor-pointer"
                onClick={() => startImmersiveReader()}
            />
        </div>
    );
};
